{
  "settings_title": "Признание",
  "settings_description": "Признание заслуг и благодарности",
  "permission_type_view": "Видеть",
  "permission_type_view_and_gift": "Видеть и дарить",
  "column_recognition": "Награда",
  "column_given_by": "Отправил",
  "revoked_by": "Отозвано {name}",
  "revoke": "Отозвать",
  "revoke_question": "Отозвать награду",
  "revoke_confirm": "Вы уверены, что хотите отозвать {title} у {name}?",
  "history_empty_title": "Пока нет выдач",
  "history_empty_description": "Здесь появятся отправленные награды.",
  "history_search_placeholder": "Поиск по сотруднику",
  "filter_recognitions": "Награды",
  "filter_recipient": "Получатель",
  "filter_awarded_by": "Отправитель",
  "recognitions_count": "{count, plural, one {# признание} few {# признания} many {# признаний} other {# признаний}}",
  "category_create_title": "Новая категория",
  "category_create_caption": "признаний",
  "category_edit_title": "Изменить категорию",
  "category_delete": "Удалить категорию",
  "category_delete_named": "Удалить категорию {title}",
  "category_delete_confirm": "Вы уверены, что хотите удалить категорию {title}?",
  "category_delete_unavailable": "Нельзя удалить категорию",
  "category_delete_contains": "В категории есть признания",
  "gift_modal_title": "Отправка признания",
  "gift_recipient_label": "Получатель",
  "gift_choose_recipient": "Выберите получателя...",
  "gift_recipient_required": "Выберите получателя",
  "gift_send_to": "Отправить",
  "gift_multiple_recipients": "нескольким получателям",
  "gift_comment_label": "Комментарий",
  "gift_comment_placeholder": "Добавьте комментарий...",
  "gift_create_recipient_group": "Добавить группу получателей",
  "gift_return_to": "Вернуться к",
  "gift_single_recipient": "одному получателю",
  "gift_recipients_count": "{count, plural, one {# сотрудник получит признание} few {# сотрудника получат признание} many {# сотрудников получат признание} other {# сотрудников получат признание}}",
  "gift_recipients_caption": "получат признание",
  "gift_send": "Отправить признание",
  "gift_success": "Отправлено!",
  "gift_recipients_gifted": "{count, plural, one {# сотрудник получил ваше признание.} few {# сотрудника получили ваше признание.} many {# сотрудников получили ваше признание.} other {# сотрудников получили ваше признание.}}",
  "gift_gifted_to": "{name} получил ваше признание.",
  "gift_recognition_title": "Отправить признание...",
  "gift_recognition_caption": "Одному или нескольким сотрудникам",
  "recognition_delete": "Удалить...",
  "recognition_delete_named": "Удалить признание {title}",
  "recognition_delete_confirm": "Вы уверены, что хотите удалить признание {title}?",
  "recognition_delete_unavailable": "Нельзя удалить признание",
  "recognition_delete_granted": "Признание уже отправляли",
  "column_created_by": "Создал",
  "column_awarded_to": "Получатели",
  "granted_count": "{count, plural, one {# сотрудник} few {# сотрудника} many {# сотрудников} other {# сотрудников}}",
  "search_placeholder": "Название признания",
  "recognition_create_title": "Новое признание",
  "recognition_edit_title": "Изменить признание",
  "profile_title": "Признание",
  "by_author": "От {name}",
  "profile_count": "{count, plural, one {# признание от коллег и руководителей} few {# признания от коллег и руководителей} many {# признаний от коллег и руководителей} other {# признаний от коллег и руководителей}}",
  "view_title": "Просмотр признания",
  "actions": "Действия",
  "awarded_by": "Признание отправил",
  "comment": "Комментарий",
  "menu_edit": "Изменить признание",
  "menu_delete": "Удалить признание",
  "delete_confirm": "Вы уверены, что хотите удалить признание {title}?",
  "edit_title": "Изменить признание",
  "field_awarded_at": "Дата отправки",
  "profile_gift": "Отправить признание",
  "gift_award": "Отправить признание",
  "view_all": "Все признания",
  "feature_title": "Признание",
  "feature_description": "Позвольте сотрудникам отмечать достижения коллег и благодарить их.",
  "gift_search_placeholder": "Название признания",
  "field_category": "Категория",
  "field_category_placeholder": "Выберите категорию...",
  "field_badge": "Бейдж",
  "art_required": "Загрузите изображение бейджа",
  "gift_rules_title": "Кто может отправлять",
  "gift_rules_caption": "Отправлять признания из этой категории могут только сотрудники, подходящие под правила. Оставьте пустым, чтобы отправка была недоступна.",
  "gift_disabled_tag": "Отправка выключена",
  "gift_disabled_hint": "У категории нет правил — отправлять признания из неё пока никто не может. Задайте правила в настройках категории, чтобы разрешить отправку.",
  "gift_no_available_title": "Нет признаний для отправки",
  "profile_empty_title": "Пока нет признаний",
  "profile_empty_description": "У сотрудника пока нет признаний.",
  "category_recognitions_empty_title": "Пока нет признаний",
  "category_recognitions_empty_description": "Добавьте признание в эту категорию.",
  "give_first_recognition": "Отправить первое признание",
  "give_recognition": "Отправить признание",
  "view_recognitions": "Смотреть {count, plural, one {# признание} few {# признания} many {# признаний} other {# признаний}}"
}
